<template>
  <div class="noselect">
    <b-container fluid class="header">
      <b-row>
        <b-col cols="12">
          <img class="p-3 logo mx-auto d-block" src="../../assets/img/easytick_color.png">
        </b-col>
      </b-row>
    </b-container>
    <b-container fluid>
      <b-row>
        <b-col md="6" offset-md="3" xl="4" offset-xl="4" class="check-ticket-veracity">
          <h1 class="text-center my-4">Conferir veracidade de ingresso digital</h1>

          <div v-if="response.show" class="my-3">
            <h2 class="mb-4 success text-center">Este ingresso digital é verdadeiro!</h2>
            <b-list-group class="mb-5">
              <b-list-group-item><strong>Evento:</strong> {{ response.data.event.name }}</b-list-group-item>
              <b-list-group-item><strong>Titular:</strong> {{ response.data.owner.name }}</b-list-group-item>
              <b-list-group-item><strong>CPF:</strong> {{ response.data.owner.document }}</b-list-group-item>
              <b-list-group-item><strong>Número do ingresso:</strong> {{ response.data.ticket.number }}</b-list-group-item>
            </b-list-group>

            <b-button variant="danger" @click="checkAnother">Conferir outro ingresso</b-button>
          </div>

          <b-col v-else>
            <b-form @submit="onSubmit">
              <h2 class="mb-3">Identificação do ingresso</h2>
              <!-- Código de segurança -->
              <b-form-group
                label="Código de segurança:"
                label-for="input-ticket-code"
                description="Informe o código de segurança do ingresso"
              >
                <b-form-input
                  id="input-ticket-code"
                  v-model="formChecker.ticket.code"
                  type="text"
                  v-mask="'hhhh hhhh hhhh hhhh hhhh hhhh hhhh hhhh'"
                  autocomplete="off"
                  :autofocus="true"
                  required
                ></b-form-input>
              </b-form-group>

              <!-- Número ingresso -->
              <b-form-group
                label="Número do ingresso:"
                label-for="input-ticket-number"
                description="Informe o número do ingresso"
              >
                <b-form-input
                  id="input-ticket-number"
                  v-model.number="formChecker.ticket.number"
                  type="number"
                  autocomplete="off"
                  required
                ></b-form-input>
              </b-form-group>

              <!-- CPF do titular -->
              <b-form-group
                label="CPF do titular:"
                label-for="input-owner-document"
                description="Informe o CPF do titular"
              >
                <b-form-input
                  id="input-owner-document"
                  v-model="formChecker.owner.document"
                  type="text"
                  v-mask="'###.###.###-##'"
                  autocomplete="off"
                  required
                ></b-form-input>
              </b-form-group>

              <b-button type="submit" variant="primary">Conferir veracidade</b-button>

              <span class="d-block my-3 captcha font-weight-lighter text-muted">Esta página é protegida pelo reCAPTCHA e está sujeita à <a href="https://www.google.com/policies/privacy/" target="_blank">Política de privacidade</a> e aos <a href="https://www.google.com/policies/terms/" target="_blank">Termos de serviço</a> do Google.</span>
            </b-form>
          </b-col>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'PublicIdCheckVeracity',
  data () {
    return {
      formChecker: {
        ticket: {
          code: '',
          number: ''
        },
        owner: {
          document: ''
        }
      },
      response: {
        show: false,
        data: {}
      }
    }
  },
  created () {

  },
  methods: {
    async onSubmit (event) {
      this.$wait.start()
      event.preventDefault()
      await this.$recaptchaLoaded()
      let recaptcha = await this.$recaptcha('webapp_check_ticket_veracity')

      let ticketCode = String(this.formChecker.ticket.code).replace(/\s/g, '')
      let ownerDocument = String(this.formChecker.owner.document).replace(/\D/g, '')

      let url = process.env.VUE_APP_URL_APP + `/b/tickets/${ticketCode}/${this.formChecker.ticket.number}/owners/${ownerDocument}/check`
      let postData = {
        recaptcha: recaptcha,
      }

      try {
        let checkResponse = await this.$http.post(url, postData)

        if (checkResponse.ok) {
          this.response.data = checkResponse.body
          this.response.show = true
          this.formChecker.ticket.number = ''
          this.formChecker.ticket.code = ''
          this.formChecker.owner.document = ''
          return
        }
      } catch (err) {
        alert(err.body.message)
      }
    },
    checkAnother () {
      this.response.show = false;
    }
  }
}
</script>

<style lang="scss" scoped>
.check-ticket-veracity {
  h1 {
    font-size: 23px;
    color: #1c4b57;
    font-weight: bold;
    text-transform: uppercase;
    background: #fff;
  }
  h2 {
    font-size: 18px;
    color: #205866;
    font-weight: bold;
    border-bottom: 1px solid #ececec;
  }
  .success {
    color: #10d419;
    font-size: 22px;
    border: none;
    font-weight: 400;
  }
}
</style>
